export const TIMELINE_INJECTION_KEY = 'timeline'
